import { PayinOrderStatus } from '~/entities/payin';

export const isAskProofsEnabled = (status?: PayinOrderStatus) => {
    return status === PayinOrderStatus.STATUS_MERCHANT_CONFIRMED;
};
